/* eslint-disable max-len */
/* eslint-disable no-undef */
import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import MasterService from '../../../../../services/MasterService';
import UserService from '../../../../../services/UserService';
import ToastService from '../../../../../services/ToastService';
import noimageSvg from '../../../../../public/noimage.svg';
import uploadicoSvg from '../../../../../public/uploadfileico.svg';
import drequipSvg from '../../../../../public/stethoscope.svg';
import { showLoading, GlobalLoading } from 'react-global-loading';
import { userData } from "../../products/ViewProducts";

class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      pwdValidation: {},
      selectedCertiIndex: '',
      selectedCenterIndex: '',
      user: this.props.selectedUser ? this.props.users[this.props.selectedUser] : { name: "Practitioners", id: 4 },
      selectedPractionerCountry: userData.roles === 'administrator' ? 0 : userData?.blog_id?.userblog_id,
      selectedCategory: [],
      selectedPractitionerCategory: [],
      centerServices: [],
      imageLogoApi: '',
      myImgApi: '',
      userData: this.props?.userData || this.props?.location?.state?.userData || [],
      type: this.props.type || this.props.location?.state?.type || 'create',
      physicianName: '',
      centerData: [],
      certificateData: [],
      selectedRole: '',
      certificateDesc: '',
      centerAddress: '',
      username: '',
      contact: '',
      pincode: '',
      selectedCity: '',
      selectedState: '',
      centerEmail: '',
      practitionerEmail: '',
      certificate: [],
      countries: [],
      categories: [],
      centerTime: [],
    };
  }

  componentDidMount = () => {
    ['view', 'edit'].includes(this.state.type) ? this.getUserDetail(this.state.userData?.ID ? this.state.userData?.ID : this.state.userData.id) : '';
    this.getAllCountries();
    this.getCategories();
  };
  getUserDetail = (id) => {
    UserService.getUsersDetail(id)
      .then((result) => {
        if (!result) {
          return;
        }

        this.setState({
          username: result.data.display_name,
          consultingFee: result.data?.fee,
          practitionerEmail: result.data?.user_email,
          imageLogoApi: result.data?.logoImg,
          myImgApi: result.data?.user_image,
          selectedPractionerCountry: result.data.user_country.id,
          selectedPractitionerCategory: result.data.domain,
          centerData: result.data.centerData,
          certificateData: result.data.certificateData,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getCategories = () => {
    MasterService.getCategories()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ categories: result });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getAllCountries = () => {
    MasterService.getAyushCountries()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ countries: result });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  handleBlur = (e) => {
    const { name } = e.target;
    this.validate(name);
  };

  validate = (field) => {
    const { username, practitionerEmail, password, confirmPassword, type } = this.state;
    let updatedErrors = {};

    // Username validation
    if (field === 'username' || field === 'all') {
      if (!username) {
        updatedErrors.username = 'Name is required';
      } else if (!/^[a-zA-Z\s]*$/.test(username)) {
        // Regex to allow only letters and spaces
        updatedErrors.username = 'Name cannot contain special characters';
      }
    }

    // Email validation
    if (field === 'practitionerEmail' || field === 'all') {
      if (!practitionerEmail) {
        updatedErrors.practitionerEmail = 'Email is required';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(practitionerEmail)) {
        updatedErrors.practitionerEmail = 'Invalid email address';
      }
    }

    // Password and Confirm Password validation (for 'create' type only)
    if (type === 'create') {
      if (field === 'password' || field === 'all') {
        if (!password) {
          updatedErrors.password = 'Password is required';
        } else if (!/(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[@$!%*#?~(&)+=^_-]).{8,}/.test(password)) {
          updatedErrors.password = 'Password must be at least 8 characters long and include alphanumeric and special characters';
        }
      }
      if (field === 'confirmPassword' || field === 'all') {
        if (password !== confirmPassword) {
          updatedErrors.confirmPassword = 'Passwords do not match';
        }
      }
    }

    // Update state with errors
    this.setState({ pwdValidation: updatedErrors });

    // Return true if there are no errors
    return Object.keys(updatedErrors).length === 0;
  };

  onUserCreation = () => {

    if (this.validate('all')) {
      const { selectedPractionerCountry, certificateData, centerData, username, consultingFee, imageLogoApi, myImgApi, user, practitionerEmail, selectedPractitionerCategory, password, userData, type, confirmPassword } = this.state;
      showLoading(true);
      const data = new FormData();
      data.append('username', username);
      data.append('fee', consultingFee);
      data.append('role', user?.name);
      data.append('user_email', practitionerEmail);
      data.append('logoImg', imageLogoApi);
      data.append('myImg', myImgApi);
      type === 'create' ? '' : data.append('ID', userData.ID);
      type === 'create' ? data.append('password', password) : '';
      data.append('user_country', selectedPractionerCountry);
      data.append('centerData', centerData);
      data.append('category', selectedPractitionerCategory);
      data.append('certificateData', certificateData);

      if (this.props.location?.state?.editData) {
        data.append('userid', userData.ID);
        UserService.updateUser(data)
          .then((result) => {
            if (result.status === 200) {
              ToastService.success(result.data[0]);
              window.history.back();
              showLoading(false);
            } else {
              showLoading(false);
              ToastService.error(result.data[0]);
            }
          });
      } else {
        UserService.createUser(data)
          .then((result) => {
            if (result.status === 200) {
              showLoading(false);
              if (this.props?.dismissModal) {
                this.props?.dismissModal();
              } else {
                window.history.back();
              }
            } else {
              ToastService.error(result.data[0]);
              showLoading(false);
            }
          });
      }
    }
    else {
      ToastService.error("Please fix validation errors before submitting.");
    }
  };
  // toggleStatus = (status, index) => {

  //   const arr = this.state.centerStatus;
  //   arr.splice(index, 1, { name: this.state.centerStatus[index].name, status: !status });
  //   this.setState({ centerStatus: arr });
  // };
  // Category Selection Functions
  // Handle Change in Consulting Fee

  handleCategories = (status, catId) => {
    if (status === true) {
      this.setState({
        selectedCategory: [...this.state.selectedCategory, catId],
      });
    } else {
      this.setState({
        selectedCategory: this.state.selectedCategory.filter((item) => item !== catId),
      });
    }
  };

  // Handle Change in Consulting Fee
  handleChange = (e) => {
    this.setState({ consultingFee: e.target.value });
  };

  // Practitioner Category Selection Functions
  handlePracCategories = (status, catId) => {
    if (status === true) {
      this.setState({
        selectedPractitionerCategory: [...this.state.selectedPractitionerCategory, catId],
      });
    } else {
      this.setState({
        selectedPractitionerCategory: this.state.selectedPractitionerCategory?.filter((item) => item !== catId),
      });
    }
  };

  // Certificate Creation Functions
  onCertificateCreation = () => {
    const { certificateTitle, certificateDesc, certificateApi, userData } = this.state;
    if (certificateTitle && certificateApi) {
      this.setState({
        certificateData: [...this.state.certificateData, { 'certificateTitle': certificateTitle, 'certificateDesc': certificateDesc, 'certificateApi': certificateApi }],
      });

      const data = new FormData();
      data.append('certificateTitle', certificateTitle);
      data.append('certificateDesc', certificateDesc);
      data.append('certificateApi', certificateApi);
      data.append('userid', userData.ID);
      UserService.updateUser(data).then((result) => {
        showLoading(true);
        if (result.status === 200) {
          showLoading(false);
          ToastService.success(result.data.message);
          document.getElementById('closeCertButton').click();
          this.setState({ certificateTitle: '', certificateDesc: '', certificateApi: '' });
        } else {
          showLoading(false);
          ToastService.error(result.data.message);
        }
      });
    } else {
      ToastService.error("Please fill required fields");
    }
  };

  // Center Time Management Functions
  onCenterTimeStatus = (index, status) => {
    const centerTime = [...this.state.centerTime];
    const centertimestatus = { ...centerTime[index] };
    centertimestatus.status = status;
    centerTime[index] = centertimestatus;
    this.setState({ centerTime });
  };

  onCenterTimeStart = (index, status) => {
    const centerTime = [...this.state.centerTime];
    const centertimestatus = { ...centerTime[index] };
    centertimestatus.start = status;
    centerTime[index] = centertimestatus;
    this.setState({ centerTime });
  };

  onCenterTimeEnd = (index, status) => {
    const centerTime = [...this.state.centerTime];
    const centertimestatus = { ...centerTime[index] };
    centertimestatus.end = status;
    centerTime[index] = centertimestatus;
    this.setState({ centerTime });
  };

  // Center Service Functions
  onCenterServices = (e) => {
    if (e.target.value && e.key === "Enter") {
      this.setState({ centerServices: [...this.state.centerServices, e.target.value], centerService: '' });
    }
  };

  deleteService = (index) => {
    let arr = this.state.centerServices;
    arr = [...arr.slice(0, index), ...arr.slice(index + 1)];
    this.setState({ centerServices: arr });
  };

  // Certificate Selection and Deletion Functions
  onCertificateSelection = (event) => {
    this.setState({
      certificateApi: event.target.files[0],
    });
  };

  deleteCertificate() {
    this.setState({ certificateApi: '' });
  }

  // Password Confirmation Function
  samePwdCheck = (password, confirmPwd) => {
    if (password === confirmPwd) {
      this.setState({ pwdConfirm: " " });
    } else {
      this.setState({
        pwdConfirm: <div className="isaerror" role="alert">Confirm password is not matched</div>
      });
    }
  };

  // Center Creation Function
  onCenterCreation = () => {
    const { physicianName, centerName, selectedCategory, centerServices, centerTime, pincode, contact, centerEmail, centerAddress, userData, selectedState, selectedCity } = this.state;
    if (physicianName && centerName && selectedCategory && centerEmail) {
      const centerEmailregex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      const mobPattern = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i);

      if (contact) {
        if (!mobPattern.test(contact) || contact.length !== 10) {
          return ToastService.error("Please enter a valid mobile");
        }
      }
      if (pincode) {
        if (pincode.length !== 6) {
          return ToastService.error("Please enter a valid pincode");
        }
      }

      if (!centerEmailregex.test(centerEmail)) {
        return ToastService.error("Please enter a valid centerEmail");
      }

      this.setState({
        centerData: [...this.state.centerData, { 'physicianName': physicianName, 'centerName': centerName, 'selectedCategory': selectedCategory, 'centerServices': centerServices, 'centerTime': centerTime, 'pincode': pincode, 'contact': contact, 'centerEmail': centerEmail, 'centerAddress': centerAddress, 'centerState': selectedState, 'centerCity': selectedCity }],
      });

      const data = { 'physicianName': physicianName, 'centerName': centerName, 'selectedCategory': selectedCategory, 'centerServices': centerServices, 'centerTime': centerTime, 'pincode': pincode, 'contact': contact, 'centerEmail': centerEmail, 'centerAddress': centerAddress, 'centerState': selectedState, 'centerCity': selectedCity, 'userid': userData.ID };
      UserService.updateUser(data).then((result) => {
        showLoading(true);
        if (result.status === 200) {
          showLoading(false);
          ToastService.success(result.data.message);
          document.getElementById('closeCertButton').click();
          this.setState({ certificateTitle: '', certificateDesc: '', certificateApi: '' });
        } else {
          showLoading(false);
          ToastService.error(result.data.message);
        }
      });
      document.getElementById('closeCenterButton').click();
      this.setState({
        'physicianName': '',
        'centerName': '',
        'selectedCategory': '',
        'centerServices': [],
        'centerTime': '',
        'pincode': '',
        'contact': '',
        'centerEmail': '',
        'centerAddress': ''
      });
    } else {
      ToastService.error("Please fill required fields");
    }
  };

  render() {
    const { countries, selectedPractionerCountry, centerAddress, username, contact, pincode, selectedCity, selectedState, centerEmail, user, myImgApi, imageLogoApi, centerName, consultingFee, certificateTitle, certificateDesc, certificateApi, categories, centerTime, centerServices, centerService, physicianName, selectedCategory, practitionerEmail, centerData, certificateData, selectedCertiIndex, selectedCenterIndex, type, selectedPractitionerCategory, confirmPassword, password, pwdValidation } = this.state;

    const centerServices1 = centerData[selectedCenterIndex]?.centerServices ? centerData[selectedCenterIndex]?.centerServices : centerServices;
    const newDocHtml = <div className="modal-dialog modal-xl">
      <GlobalLoading />
      <div className="modal-content bg-white p-3">
        <div className="modal-header">
          <h1 className="modal-title fs-5 w-100" id="certificateapprovalLabel">Add new certification</h1>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => URL.revokeObjectURL(certificateApi)}></button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 p-1 bg-light">

              <div className="row">
                <div className="col-md-8 docdesc">
                  <p className="mb-1">Certificate Name*</p>
                  <div className="form-group position-relative">
                    <input disabled={type === 'view'} type="text" aria-labelledby="certificatetitle" id="certificatetitle" className="form-control pd-tb-675em pb-3 docdesc" placeholder="Update the document name here" name="proposeapprove" value={certificateTitle || certificateData[selectedCertiIndex]?.certificateTitle}
                      onChange={(e) => this.setState({ certificateTitle: e.target.value })} />
                  </div>
                </div>
                <div className="col-md-8 docdesc">
                  <p className="mb-1">Certificate Description</p>
                  <div className="form-group position-relative">
                    <input disabled={type === 'view'} type="text" aria-labelledby="aboutcertificate" id="aboutcertificate" className="form-control pd-tb-675em pb-3 docdesc_in" placeholder="Update the comments here" name="proposeapprove" value={certificateDesc || certificateData[selectedCertiIndex]?.certificateDesc}
                      onChange={(e) => this.setState({ certificateDesc: e.target.value })} />
                  </div>
                </div>
                <div className="col-md-8 docdesc">
                  <p className="mb-1">Certificate Upload*</p>
                  {certificateApi ?
                    <> {certificateApi && <object
                      aria-labelledby="label12"
                      width="100%"
                      height="100%"
                      type="application/pdf"
                      data={URL.createObjectURL(certificateApi)}
                    />}
                      <span>  {certificateApi.name}</span>
                    </> :
                    <>  <i className="fa fa-plus fs-3 text-secondary adddocs" aria-hidden="true"></i>

                      <input disabled={type === 'view'} type="file" name="file" accept="application/pdf" aria-labelledby="uploadcertificate" id="uploadcertificate" onChange={this.onCertificateSelection} />
                      <small className="text-muted pt-3">Upload Certificate in pdf format</small>
                    </>

                  }

                  {certificateApi && <div className="d-block del-btn">
                    <button onClick={() => this.deleteCertificate()}><i className="fa fa-trash" aria-hidden="true"></i></button>
                  </div>}
                </div>
              </div>
              <div className="cercon_dw mt-3">
                <button type="button" className="btn rbnn border-2 " data-bs-dismiss="modal" id="closeCertButton" onClick={() => URL.revokeObjectURL(certificateApi)}>Close</button>
                <button type="button" className="btn theme-btn-fill border-2"
                  onClick={() => this.onCertificateCreation()} >Add Certificate</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
      newCenterHtml = <div className="modal-dialog modal-xl">
        <GlobalLoading />
        <div className="modal-content bg-white p-3">
          <div className="modal-header">
            <h1 className="modal-title fs-5 w-100" id="newcenterLabel">Add new center of {user?.name === 'Association Users' ? "Association" : "Practice"}</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="practitionername" id="physicianname" className="form-label over-label">Head Physician’s Name*</label>
                  <input disabled={type === 'view'} type="text" aria-labelledby="physicianname" className="form-control pd-tb-675em" placeholder="Enter your center name Head Physician’s Name" name="practitionername"
                    onChange={(e) => this.setState({ physicianName: e.target.value })} value={centerData[selectedCenterIndex]?.physicianName || physicianName} />
                </div>
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="clinicname" id="centername" className="form-label over-label">Center’s Name*</label>
                  <input disabled={type === 'view'} type="text" aria-labelledby="centername" className="form-control pd-tb-675em" placeholder="Enter your Center’s Name" name="clinicname" onChange={(e) => this.setState({ centerName: e.target.value })} value={centerData[selectedCenterIndex]?.centerName || centerName} />
                </div>

                <div className="form-group mb-4 position-relative">
                  <label htmlFor="eventnamee" id="subdomains" className="form-label"><b>Domains*:</b></label>
                  <div className="btn-group d-block event-check chbcn" role="group" aria-label="Basic checkbox toggle button group">
                    {selectedPractitionerCategory?.length > 0 && selectedPractitionerCategory?.map((item, index) => < span key={index + "a"}> <input aria-labelledby="subdomains" disabled={type === 'view'} type="checkbox" className="btn-check" id={index + "a"} autoComplete="off" onChange={(e) => this.handleCategories(e.target.checked, item)} checked={centerData[selectedCenterIndex]?.selectedCategory.includes(item)} />
                      <label className="btn btn-outline-dark " htmlFor={index + "a"}>{item}</label></span>)}

                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <p className="tab-head">Center’s Timings</p>
                <table className="table table-striped time-tab">
                  <tbody>
                    {['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'].map((item, index) => <tr key={index}>
                      <th scope="row">{item}</th>
                      <td>
                        <label
                          // {`branch d-flex justify-content-center flex-column brhwr+${selectedCategory === item ? '_hvr' : ``}`}
                          className={`btn btn-outline-dark + ${centerTime[index]?.status === 'open' ? `drkbn` : ''}`} id="dayss" htmlFor={"centertime" + index}>Open</label>
                        <input disabled={type === 'view'} type="checkbox" name={"centertime" + index} id={"centertime" + index} aria-labelledby="dayss" className="btn-check" autoComplete="off" onChange={(e) => this.onCenterTimeStatus(index, e.target.checked ? 'open' : 'close')} checked={centerTime[index]?.status === 'open' ? true : false} />
                      </td>
                      <td>
                        <div className="form-group position-relative">
                          <input disabled={type === 'view'} type='time' id="starttime" aria-labelledby="starttime" className="form-control" data-date-format="HH : MM"
                            value={centerTime[index]?.start} onChange={(e) => this.onCenterTimeStart(index, e.target.value)}
                          />
                        </div>
                      </td>
                      <td><span className="fw-bold">-to-</span></td>
                      <td>
                        <div className="form-group position-relative">
                          <input disabled={type === 'view'} type='time' id="endtime" aria-labelledby="endtime" className="form-control" data-date-format="HH : MM "
                            value={centerTime[index]?.to} onChange={(e) => this.onCenterTimeEnd(index, e.target.value)}
                          />
                        </div>
                      </td>
                    </tr>)}

                  </tbody>
                </table>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-8">
                <div className="p-3 bg-primary-subtle brdr">
                  <h5 className="text-dark mb-0">Add Services Provided by the center:</h5>
                  <div className="form-group position-relative">
                    <input disabled={type === 'view'} type="text" id="centerservice" aria-labelledby="centerservice" className="form-control mt-2 pd-tb-675em" placeholder="Type here to search services" name="searchcenter" value={centerService} onChange={(e) => this.setState({ centerService: e.target.value.trim() })} onKeyDown={(e) => this.onCenterServices(e)} />
                  </div>
                </div>
                <ul className="list-group search-list mt-3">
                  {centerServices1?.map((item, index) => <li key={index} className="list-group-item d-flex justify-content-between align-items-center">{item}
                    {type === 'view' ? '' : <i className="fa fa-window-close fs-4" aria-hidden="true" onClick={() => this.deleteService(index)}></i>}
                  </li>)}

                </ul>
              </div>
              <div className="col-md-4">
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="mailid" id="contactid" className="form-label over-label">E-mail Id*</label>
                  <input disabled={type === 'view'} type="email" aria-labelledby="contactid" className="form-control inpd" name="mailid" onChange={(e) => this.setState({ centerEmail: e.target.value })} value={centerData[selectedCenterIndex]?.centerEmail || centerEmail} />
                </div>
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="statename" id="statetitle" className="form-label over-label">State</label>
                  <input disabled={type === 'view'} type="text" aria-labelledby="statetitle" className="form-control inpd" name="pincode" onChange={(e) => this.setState({ selectedState: e.target.value })} value={centerData[selectedCenterIndex]?.selectedState || selectedState} />

                </div>
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="cityname" id="citytitle" className="form-label over-label">City</label>
                  <input disabled={type === 'view'} type="text" aria-labelledby="citytitle" className="form-control inpd" name="pincode" onChange={(e) => this.setState({ selectedCity: e.target.value })} value={centerData[selectedCenterIndex]?.selectedCity || selectedCity} />
                </div>
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="pincode" id="pincodenumber" className="form-label over-label">Pin Code</label>
                  <input disabled={type === 'view'} type="number" aria-labelledby="pincodenumber" className="form-control inpd" name="pincode" onChange={(e) => this.setState({ pincode: e.target.value })} value={centerData[selectedCenterIndex]?.pincode || pincode} />
                </div>
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="centeraddress" id="addcenteraddress" className="form-label over-label">Center’s Address</label>
                  <textarea aria-labelledby="addcenteraddress" disabled={type === 'view'} className="form-control textarea-height" name="centeraddress" rows="4" onChange={(e) => this.setState({ centerAddress: e.target.value })} value={centerData[selectedCenterIndex]?.centerAddress || centerAddress}></textarea>
                </div>
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="contactnumber" id="phonenumber" className="form-label over-label">Contact Number</label>
                  <input disabled={type === 'view'} type="number" aria-labelledby="phonenumber" className="form-control inpd" name="contactnumber" onChange={(e) => this.setState({ contact: e.target.value })} value={centerData[selectedCenterIndex]?.contact || contact} />
                </div>

              </div>

            </div>
          </div><div className="modal-footer">
            <button type="button" className="btn theme-btn-outline" data-bs-dismiss="modal" id="closeCenterButton" >Close</button>
            <button type="button" className="btn theme-btn-fill" onClick={() => this.onCenterCreation()}>Add Center</button>
          </div>
        </div>
      </div>;


    return (
      <div className="container pt-2 px-4">
        <ToastContainer />
        <div className="row mt-2">
          <div className="col-md-11 talf">
            {(this.props?.selectedUser || window.location.pathname.includes('country-users')) ? <button className="btn-close" aria-label="Close" onClick={() => this.props.dismissModal()} ></button> : ''}
            <GlobalLoading />
            <div className="head-title">
              <h4 className="prdh">{(type?.charAt(0).toUpperCase() + type?.slice(1) || '')} {user?.name}</h4>
            </div>

            <div className="flhd">
              {type === 'view' ? '' : <p className="marz">Fill the form below to create {user?.name} in a country...</p>}
              {/* <button type="button" className="btn theme-btn-fill"> </button> */}
              {/* <Link to='/edit-practice-data' className="btn theme-btn-fill"> Edit Details</Link> */}
            </div>
          </div>
        </div>
        <hr className="hrr"></hr>
        <div className="row mt-5">
          <div className="col-md-6">

            <div className="form-group mb-4 position-relative">
              <label htmlFor="eventname" className="bldlbl" id="myname">Name*</label>
              <input disabled={type === 'view'} type="text" aria-labelledby="myname" className={`form-control ${pwdValidation.username ? 'is-invalid' : ''}`} placeholder="Enter your name here" name="username" value={username} onChange={(e) => this.setState({ username: e.target.value })}
                onBlur={this.handleBlur}
              />
              {pwdValidation.username && <div className="invalid-feedback">{pwdValidation.username}</div>}

            </div>
            <div className="form-group mb-4 position-relative">
              <label htmlFor="clinicname" className="bldlbl" id="myfee">Consulting Fee</label>
              <input disabled={type === 'view'} type="number" aria-labelledby="myfee" className="form-control inpd" placeholder="Enter your Consulting Fee" name="consultingFee" value={consultingFee} onChange={(e) => this.handleChange(e)} />

            </div>
            <div className="col-md-8 docdesc">
              <p className="mb-1">Email*</p>
              <div className="form-group position-relative">
                <input
                  type="email"
                  aria-labelledby="practitionerEmail"
                  id="practitionerEmail"
                  className={`form-control ${pwdValidation.practitionerEmail ? 'is-invalid' : ''}`}
                  placeholder="Enter email"
                  name="practitionerEmail"
                  value={practitionerEmail}
                  onChange={(e) => this.setState({ practitionerEmail: e.target.value })}
                  onBlur={this.handleBlur}
                />
                {pwdValidation.practitionerEmail && <div className="invalid-feedback">{pwdValidation.practitionerEmail}</div>}
              </div>
            </div>
            {userData.roles === 'administrator' ? <div className="form-group mb-4 position-relative">
              <label htmlFor="countryname" className="bldlbl" id="country"> {user?.name} Country*</label>
              <select name='orderby' disabled={type === 'view'} className='form-control inppd' aria-labelledby="country" value={selectedPractionerCountry}
                onChange={(e) => this.setState({ selectedPractionerCountry: e.target.value })}>
                <option defaultValue='selected'>Countries*</option>
                {countries.map((item, index) => <option key={index} value={item.id}>{item.blogname}</option>)}
              </select>
            </div> : ''}
            {type === 'create' && <> <div className="form-group mb-4 position-relative">
              <label htmlFor="clinicname" className="bldlbl" id="myfee">Password</label>
              <input
                type="password"
                className={`form-control ${pwdValidation.password ? 'is-invalid' : ''}`}
                name="password"
                minLength="8"
                disabled={type !== 'create'}
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
                onBlur={this.handleBlur}
              />
              {pwdValidation.password && <div className="invalid-feedback">{pwdValidation.password}</div>}


            </div>
              <div className="form-group mb-4 position-relative">
                <label htmlFor="confirmPassword" className="bldlbl">Confirm Password</label>
                <input
                  type="password"
                  className={`form-control ${pwdValidation.confirmPassword ? 'is-invalid' : ''}`}
                  name="confirmPassword"
                  minLength="8"
                  disabled={pwdValidation.password || type !== 'create'}
                  value={confirmPassword}
                  onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                  onBlur={this.handleBlur}
                />
                {pwdValidation.confirmPassword && <div className="invalid-feedback">{pwdValidation.confirmPassword}</div>}
              </div></>}
            <div className="form-group mb-4 position-relative">
              <label htmlFor="countryname" className="bldlbl" id="pracCategory"> Category*</label>
              {categories.map((item, index) =>
                < span key={index}> <input aria-labelledby="pracCategory" disabled={type === 'view'} type="checkbox" className="btn-check" id={index} autoComplete="off" onChange={(e) => this.handlePracCategories(e.target.checked, item.name)} checked={selectedPractitionerCategory?.includes(item.name)} />
                  <label className="btn btn-outline-dark crtgaps" htmlFor={index}>{item.name}</label></span>)}
            </div>
          </div>
          <div className="col-md-6 imgcollo">
            {/* below is the center logo part */}
            <p>Centre’s Logo*:</p>
            <div className="upload-drag d-flex align-items-center justify-content-center">
              <div className="uploadbox">
                {
                  imageLogoApi ?
                    <><img src={typeof imageLogoApi === 'object' ? URL.createObjectURL(imageLogoApi) : imageLogoApi} />
                      <div className="d-block del-btn">
                        <button onClick={() => this.setState({ imageLogoApi: '' })}><i className="fa fa-trash" aria-hidden="true"></i></button>  </div> </>
                    :
                    <> <img src={noimageSvg} className="d-block noimg" alt="upload" />
                      <span className="d-block">Upload Image by clicking to upload</span>
                      <label htmlFor="productname" id="uploadimagg" className="bldlbl">Image of Logo *</label>
                      <input disabled={type === 'view'} className="upload-btn" aria-labelledby="uploadimagg" type="file" accept=".png, .jpg, .jpeg" name="file" onChange={(e) => this.setState({
                        imageLogoApi: e.target.files[0]
                      })} />
                    </>
                }
              </div>
            </div>
            {/* below is the doctor image part */}
            <p>Image*:</p>
            <div className="upload-drag d-flex align-items-center justify-content-center">
              <div className="uploadbox">
                {
                  myImgApi ?
                    <><img src={typeof myImgApi === 'object' ? URL.createObjectURL(myImgApi) : myImgApi} /> <div className="d-block del-btn">
                      <button onClick={() => this.setState({ myImgApi: '' })}><i className="fa fa-trash" aria-hidden="true"></i></button>  </div> </>
                    :
                    <> <img src={noimageSvg} className="d-block noimg" alt="upload" />
                      <span className="d-block">Upload Image by clicking to upload</span>
                      <label htmlFor="productname" id="uploadimagg_" className="bldlbl">Image of the {user?.name} </label>
                      <input disabled={type === 'view'} aria-labelledby="uploadimagg_" className="upload-btn" type="file" accept=".png, .jpg, .jpeg" name="file" onChange={(e) => this.setState({
                        myImgApi: e.target.files[0]
                      })} />
                    </>
                }
              </div>
            </div>

          </div>
        </div>
        {/* addpractitionercertificateupload */}
        {
          (certificateData.length > 0 || type === 'edit') && <div className="row mt-5 mb-3 ">
            <div className="col-md-10 event-title">
              <h4>Medical Certifications</h4>
            </div>
            <div className="col-md-2 text-end mb-3 align-middle">
              {type === "edit" ? <button type="button" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn" data-bs-toggle="modal" data-bs-target="#addpractitionercertificateupload">
                {/* <i className="fa fa-plus-circle" aria-hidden="true" />  */}
                Add New
              </button> : ''}
            </div>

            {certificateData.map((item, index) => <div className="col-md-4 mt-3 " key={index} >
              <div className="card card-ico bg-body-secondary shadow-none" data-bs-toggle="modal" data-bs-target="#addpractitionercertificateupload" onClick={() => this.setState({ selectedCertiIndex: index, type: 'view' })}>
                <div className="card-body">
                  <h5 className="card-title fs-5 fw-bold">{item.certificateTitle || item.certificate_name}</h5>
                  <small>
                    <img src={uploadicoSvg} className="float-end upload-img" alt="upload" />
                    {item.certificateDesc}</small>
                  <div className="bdcont">
                    <span className="badge upunap rounded rounded-3 bg-body-tertiary text-dark fw-bold p-2 px-8 mt-2 mb-2"> Uploaded <i className="fa fa-check-circle text-theme fs-5 align-middle" aria-hidden="true"></i></span>
                  </div>
                </div>
              </div>
            </div>)}
          </div>
        }

        {
          (centerData.length > 0 || type === 'edit') && <div className="row mt-5 mb-3 p-3 border border-secondary-subtle rounded rounded-4">
            <div className="col-md-10 event-title">
              <h4>Center Of  {user?.name === 'Association Users' ? "Association" : "Practice"} </h4>
            </div>
            <div className="col-md-2 text-end mb-3 align-middle">
              {type === 'edit' ? <button type="button" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn" data-bs-toggle="modal" data-bs-target="#newcenter">
                {/* <i className="fa fa-plus-circle" aria-hidden="true" />  */}
                Add New Center
              </button> : ''
              }
            </div>
            <hr></hr>
            {/* editcenter */}
            {centerData?.map((item, index) => <div className="col-md-4 mt-3" key={index}>
              <div data-bs-toggle="modal" data-bs-target="#newcenter" className="card pntr p-3 bg-secondary-subtle center-card">
                <div className="row" onClick={() => this.setState({ selectedCenterIndex: index, type: 'view' })}>
                  <div className="col-md-2">
                    <img src={drequipSvg} className="mt-4" alt="centers" />
                  </div>
                  <div className="col-md-10">
                    <div className="card-body">
                      <h5 className="card-title fs-5 fw-bold">{item.physicianName}
                      </h5>
                      <p className="card-text">
                        {item.centerAddress}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
          </div>
        }

        {/* -------------- create new document popup ----------------*/}
        <div className="modal fade" id="addpractitionercertificateupload" tabIndex="-1" aria-labelledby="certificateapprovalLabel" aria-hidden="true">
          {newDocHtml}
        </div>

        {/* ------------------- add a center of practice popup ------------------- */}
        <div className="modal fade newcenter" id="newcenter" tabIndex="-1" aria-labelledby="newcenterLabel" aria-hidden="true">
          {newCenterHtml}

        </div>
        {/* ------------------- new center popup end ------------------- */}

        <div className="detbottbtn mt-3">
          {window.location.pathname.includes('country-users') ? '' : <div className="btninr">
            {this.props?.selectedUser ? <button type="button" className="btn theme-btn-outline" data-bs-dismiss="modal" id="closeUserButton" onClick={() => this.props.dismissModal()} >Close</button> : <button type="button" className="btn theme-btn-outline" onClick={() => window.history.back()} >Close</button>}
            {type === 'view' ? <button type="button" onClick={() => this.setState({ type: 'edit' })} className="btn theme-btn-fill">Edit</button> : <button type="button" onClick={() => this.onUserCreation()} className="btn theme-btn-fill">Save</button>}
          </div>}
        </div>
      </div >
      // {/* ------------------- new center popup end ------------------- */ }
    );
  }
}
export default CreateUser;